import React from 'react';
import { Route } from 'react-router-dom';

import { ChainedRender } from 'Modules/core/react';
import { useConfig } from 'Modules/core/config';

import { Tracker, TrackerProps } from '../components/Tracker';


export const getTrackerRender = (props: Omit<TrackerProps, 'accountIds'>): ChainedRender =>
    ({ Next }) => {
        const accountIds = useConfig<number[]>('trackerIds');
        return (
            <>
                {process.env.NODE_ENV !== 'development' && accountIds && (
                    <Route>
                        <Tracker accountIds={accountIds} {...props} />
                    </Route>
                )}
                <Route component={Next} />
            </>
        );
    };
